export type AutoProcessConfirmMode = 'on' | 'off';

export interface AutoProcessConfirm {
  readonly enabled: boolean;
}

export interface AutoProcessConfirmCopy {
  readonly title: string;
  readonly headingLines: readonly [string, string];
  readonly bodyLines: readonly [string, string];
  readonly confirmLabel: string;
}

export const AUTO_PROCESS_CONFIRM_COPY: Record<AutoProcessConfirmMode, AutoProcessConfirmCopy> = {
  on: {
    title: 'Turn On Auto-Process',
    headingLines: ['Are you sure you want to ', 'turn on Auto-Process?'],
    bodyLines: [
      'An event will load immediately after closing, parking or escalating the previous event when this is turned on.',
      '',
    ],
    confirmLabel: 'Turn On Auto-Process',
  },
  off: {
    title: 'Turn Off Auto-Process',
    headingLines: ['Are you sure you want to ', 'turn off Auto-Process?'],
    bodyLines: [
      'Turning this off will let users pick or process an event',
      'from the Events List.',
    ],
    confirmLabel: 'Turn Off Auto-Process',
  },
};
